export default "__VITE_ASSET__CW43loFq__"